import replaceWithMarkup from "../utils/replaceWithMarkup";
import getPopularPosts from "./getPopularPosts";
import indexItemMarkup from "./indexItemMarkup";
/**
 *
 * @param morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param replaceWithPosts          Query string for node that new posts will replace.
 * @param queryParam                API query param for Parsley
 * @param page                      Pagination index.
 */
export default function loadMorePopularPosts( morePostsTrigger, replaceWithPosts, queryParam, page ) {

    const trigger = document.querySelector( morePostsTrigger );

    trigger.addEventListener( 'click', function( e ) {

        e.preventDefault();

        const btnOriginalHtml = trigger.querySelector( 'a' ).innerHTML;

        const loaderHtml = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';

        trigger.querySelector( 'a' ).innerHTML = loaderHtml;

        getPopularPosts( queryParam, page )
            .then( response => {
                const postList = response.data
                    .map(
                        function( dataItem ) {
                            const { url, image_url, title, author, pub_date, section } = dataItem;

                            const options = { year: 'numeric', month: 'long', day: 'numeric' };
                            const dateObj  = new Date( pub_date );

                            let post_id = '';
                            let postUrl = '';
                            
                            if( url.includes( 'http://www.adweek.com' ) ){
                                postUrl = url.replace( 'http://www.adweek.com', window.location.origin );
                            }
                            if( url.includes( 'https://www.adweek.com' ) ){
                                postUrl = url.replace( 'https://www.adweek.com', window.location.origin );
                            }

                            jQuery.ajax({
                                type : "post",
                                dataType : "json",
                                url : adw.ajaxurl,
                                async: false,
                                data : { action: "aw_url_to_postid", post_url: postUrl },
                                complete: function(response) {                                    
                                    if( response && response.status == 200 ){
                                    
                                        const responseData = response.responseJSON;

                                        if( response !== 0 ){
                                            post_id = responseData;
                                        }
                        
                                    } else {
                        
                                        console.log( 'Could not get post data from Wordpress' );
                        
                                    }
                                
                                }
                            });

                            return {
                                post_id,
                                url,
                                title,
                                author,
                                label: section,
                                pubDate: dateObj.toLocaleDateString( 'en-US', options ),
                                imageUrl: !image_url.includes("apple-touch-icon.png") ? adw.utils.replaceUrls(image_url) : ''
                            };
                        }
                    );
                    // .reduce(
                    //     function ( markup, dataItem ) {
                    //         return markup + indexItemMarkup( dataItem );
                    //     }, '');

                    let postIdList = postList.map( (post) => post.post_id );

                    let postIdListFiltered = postIdList.filter( (post_id) => post_id !== 0 );
                    
                    let postsMarkup = '';

                    adw.posts.getPostsMarkupByIDs( postIdListFiltered, 'index_item' ).then( (markupList) => {
                        postsMarkup = markupList.reduce( (markup, item) => markup + item );

                        const reinitialize = (postsMarkup !== '');

                        trigger.querySelector( 'a' ).innerHTML = btnOriginalHtml;
                        replaceWithMarkup( trigger, postsMarkup, replaceWithPosts, reinitialize );


                        if ( reinitialize ) {

                            loadMorePopularPosts( morePostsTrigger, replaceWithPosts, queryParam, ++page );

                        }

                    } );

            });

    }, { once: true } );

}
